import {setCookie} from 'general/libs/setCookie';
import {ANALYTICS, CODE, COOKIE_VALUE, PLATFORM, STATE} from 'general/constants';
import {duration, dyData, modal} from 'general/store';
import {pushPopupEvent} from 'general/libs/pushDataLayer';
import {get} from 'svelte/store';
import type {AxiosInstance} from 'axios';
import {getRefId} from 'general/libs/getRefId';
import {sendGenderToCordial} from 'general/libs/sendGenderToCordial';

/**
 * changes popup side and updates animations to correct transition
 * @param state - new popup state to change side
 */
const updateStateAndSetAnimations = (state: $Values<typeof STATE>) => {
    duration.update('flip', {in: 600});
    duration.update('opacity', {in: 350});
    modal.changeState(state);
};

type PropsType = {
    instance: AxiosInstance;
    subscribeEvent: string;
    isCart: boolean;
    code: number;
};
/**
 * handler for when user was subscribed or already subscribed
 * @param {AxiosInstance} instance - instance for refId call
 * @param {string} subscribeEvent - analytic event that will be pushed no matter what
 * @param {boolean} isCart - is exit cart template
 * @param {number} code - response code to detect on what side popup should be changed
 */
export const handleSubscribe = ({instance, subscribeEvent, isCart, code}: PropsType) => {
    const {email, radioValue, platform} = get(modal);
    const {firstSide, side, isMobile} = get(dyData);
    const isFirstSideSms = firstSide === STATE.SMS;

    // set localStorage items and cookies
    setCookie(COOKIE_VALUE.SUBSCRIBER, 'true', 365);
    localStorage.setItem('popupEmail', email);

    if (isFirstSideSms || platform === PLATFORM.DESKTOP) {
        setCookie('IS_FIRST_DAY_SUBSCRIBER', 'true', 1);
    }

    // push subscribe event
    pushPopupEvent(subscribeEvent, {email});

    // connect radio value to gender filters
    if (radioValue) {
        pushPopupEvent(`${radioValue} - Marked`);
        const isMale = radioValue === 'Male';

        if (isMale || radioValue === 'Female') {
            sendGenderToCordial({
                instance,
                email,
                gender: radioValue.toLowerCase(),
                storeId: isMobile ? 10 : 1,
            });
            window.dispatchEvent(
                new CustomEvent('popup:setDefaultGender', {
                    detail: {
                        // gender key for filters uses 4 for male and 5 for women
                        gender: isMale ? '4' : '5',
                    },
                }),
            );
        }
    }

    if (isFirstSideSms || isCart || (side.typ && !side.sms)) {
        const changeState = code === CODE.SUCCESSFUL ? STATE.TYP : STATE.ALREADY_SUBSCRIBED;
        updateStateAndSetAnimations(changeState);
        return;
    }

    if (side.sms) {
        // we should check if refId has been created for sms side
        getRefId(instance, email).then((refId: string) => {
            if (!refId) {
                setCookie(COOKIE_VALUE.SUBSCRIBER_PHONE, 'true', 365);
                pushPopupEvent(ANALYTICS.REFID_ERROR, {email});
                modal.hideCurrentPopup();
                return;
            }
            modal.changeRefId(refId);
            updateStateAndSetAnimations(STATE.SMS);
            pushPopupEvent(ANALYTICS.POPUP_SHOWED_SMS);
        });
    }
};
